export default __webpack_public_path__ + "static/media/beta_version.72c2ee0a.png";